import type { IconAnimation } from '~/chords/Icon/types';
import { cn } from '~/chords/lib/cn';

export const getAnimationClassName = (animation?: IconAnimation) => {
  if (!animation) {
    return undefined;
  }

  switch (animation) {
    case 'spin-reverse':
      return cn('fa-spin fa-spin-reverse');
    case 'spin-pulse-reverse':
      return cn('fa-spin fa-spin-pulse fa-spin-reverse');
  }

  return `fa-${animation}`;
};
